export const PDPA_RETREIVE_RESADDRESS_REQUEST = 'PDPA_RETREIVE_RESADDRESS_REQUEST';
export const PDPA_RETREIVE_RESADDRESS_SUCCESS = 'PDPA_RETREIVE_RESADDRESS_SUCCESS';
export const PDPA_RETREIVE_RESADDRESS_FAILURE = 'PDPA_RETREIVE_RESADDRESS_FAILURE';

export const PDPA_SAVE_NEW_RESADDR_REQUEST = 'PDPA_SAVE_NEW_RESADDR_REQUEST';
export const PDPA_SAVE_NEW_RESADDR_SUCCESS = 'PDPA_SAVE_NEW_RESADDR_SUCCESS';
export const PDPA_SAVE_NEW_RESADDR_FAILURE = 'PDPA_SAVE_NEW_RESADDR_FAILURE';

export const PDPA_UPDATE_EXIST_RESADDR_REQUEST = 'PDPA_UPDATE_EXIST_RESADDR_REQUEST';
export const PDPA_UPDATE_EXIST_RESADDR_SUCCESS = 'PDPA_UPDATE_EXIST_RESADDR_SUCCESS';
export const PDPA_UPDATE_EXIST_RESADDR_FAILURE = 'PDPA_UPDATE_EXIST_RESADDR_FAILURE';

export const PDPA_DELETE_EXIST_RESADDR_REQUEST = 'PDPA_DELETE_EXIST_RESADDR_REQUEST';
export const PDPA_DELETE_EXIST_RESADDR_SUCCESS = 'PDPA_DELETE_EXIST_RESADDR_SUCCESS';
export const PDPA_DELETE_EXIST_RESADDR_FAILURE = 'PDPA_DELETE_EXIST_RESADDR_FAILURE';

export const GET_ESIM_CARD_PROFILE_TYPE = 'GET_ESIM_CARD_PROFILE_TYPE';
export const GET_ESIM_CARD_PROFILE_TYPE_SUCCESS = 'GET_ESIM_CARD_PROFILE_TYPE_SUCCESS';
export const GET_ESIM_CARD_PROFILE_TYPE_FAILURE = 'GET_ESIM_CARD_PROFILE_TYPE_FAILURE';

export const UPLOAD_MULTILINE_RECEIPIENTS_ESIM_REQUEST = 'UPLOAD_MULTILINE_RECEIPIENTS_ESIM_REQUEST';
export const UPLOAD_MULTILINE_RECEIPIENTS_ESIM_SUCCESS = 'UPLOAD_MULTILINE_RECEIPIENTS_ESIM_SUCCESS';
export const UPLOAD_MULTILINE_RECEIPIENTS_ESIM_FAILURE = 'UPLOAD_MULTILINE_RECEIPIENTS_ESIM_FAILURE';

export const UPLOAD_MULTILINE_RETRIGGER_ESIM_REQUEST = 'UPLOAD_MULTILINE_RETRIGGER_ESIM_REQUEST';
export const UPLOAD_MULTILINE_RETRIGGER_ESIM_SUCCESS = 'UPLOAD_MULTILINE_RETRIGGER_ESIM_SUCCESS';
export const UPLOAD_MULTILINE_RETRIGGER_ESIM_FAILURE = 'UPLOAD_MULTILINE_RETRIGGER_ESIM_FAILURE';

export const DOWNLOAD_MULTILINE_RECEIPIENTS_ESIM_REQUEST = 'DOWNLOAD_MULTILINE_RECEIPIENTS_ESIM_REQUEST';
export const DOWNLOAD_MULTILINE_RECEIPIENTS_ESIM_SUCCESS = 'DOWNLOAD_MULTILINE_RECEIPIENTS_ESIM_SUCCESS';
export const DOWNLOAD_MULTILINE_RECEIPIENTS_ESIM_FAILURE = 'DOWNLOAD_MULTILINE_RECEIPIENTS_ESIM_FAILURE';
export const DOWNLOAD_MULTILINE_RECEIPIENTS_ESIM_RESET = 'DOWNLOAD_MULTILINE_RECEIPIENTS_ESIM_RESET';